import React, { useState, useEffect } from 'react';
import moment from 'moment';

import _ from 'lodash';
import DimpleDivider from '@tds/core-dimple-divider';
import Spinner from '@tds/core-spinner';
import axios from 'axios';
import InputGroup from '@tds/community-input-group';
import Filters from '../../components/filters';
import MessageNotification from '../messageNotification';
import stringInterpolation from '../utils/stringInterpolation';
import FileDownload from 'js-file-download';
import queryString from 'query-string';
import Button from '@tds/core-button';
import 'react-responsive-modal/styles.css';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import { apiHost, config as axiosConfig } from '../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../design/css';
import { Search, TableBottomBar } from './css';
import { getPathVariables } from '../misc';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import Table from './Table';
import Pagination from './Pagination';
import ExportOrdersModal from './ExportOrdersModal';
import {
  orderNotEligibleforMssReason,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  reasonForSubmissionFrenchMappings,
  orderIsNotEligibleForMSSFrenchMappings,
  orderIsNotEligibleForMSS,
  orderWasReturned
} from '../utils/constant';
import { getFormattedDate } from '../utils/utils';
import { getOptions, ChannelModel } from '../orders/models';

const connectionKey = 'ORDERS';

const addDevicesAndAccessoriesValues = ordersList => {
  const devicesOnlyOrAccessoriesOnly = [
    DevicesOnlyEnglish,
    DevicesOnlyFrench,
    AccessoriesOnlyEnglish,
    AccessoriesOnlyFrench
  ];
  return ordersList.map(order => {
    if (
      !order.installationTypeWLS &&
      order[orderNotEligibleforMssReason] &&
      order[orderNotEligibleforMssReason].length &&
      devicesOnlyOrAccessoriesOnly.includes(
        order[orderNotEligibleforMssReason][0]
      )
    ) {
      return {
        ...order,
        installationTypeWLS: order[orderNotEligibleforMssReason][0]
      };
    }
    return order;
  });
};

const initialFilterState = {
  startDate: null,
  endDate: null,
  filterCriteria: null,
  channelId: [],
  province: [],
  assignee: [],
  createdBy: [],
  status: [],
  dealership: [],
  reasonForSubmission: null,
  orderNotEligibleforMssReason: [],
  flag: null,
  reasonForOrderReturned: []
};

const AllOrdersDashboardWLS = ({ handleHistoryPush, history }) => {
  const local = useLocaleContext();
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        WLSLandingPage: { searchLabel, searchHint }
      }
    },
    srtDashboard: { successActionMessage, cancelAction },
    ORDERS: { wlsFiltersStatusOptions }
  } = local === 'en-US' ? EN : FR;
  const localizedStrings = useLocalizedStringsContext();
  const staticLabels = localizedStrings[connectionKey];
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'salesRepDashboard',
    locale
  };
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { provinces } = userProfile;

  let url = '';
  const { q } = queryString.parse(history.location.search);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [pageLayout, setPageLayout] = useState();
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [searchString, setSearchString] = useState(q);
  const [filters, setFilters] = useState('');
  const [exportingOrders, setExportingOrders] = useState(false);
  const [isExportPopupVisible, setExportPopupVisible] = useState(false);
  const [pageNumber, setPageNumber] = useState(() => {
    const AllOrdersPageWLS = localStorage.getItem('AllOrdersPageWLS')
      ? localStorage.getItem('AllOrdersPageWLS')
      : 1;
    return AllOrdersPageWLS;
  });
  const [salesRepNames, setSalesRepNames] = useState(null);
  const [channels, setChannels] = useState(null);
  const [dealerships, setDealerships] = useState(null);
  const [isDelete, setIsDelete] = useState({});
  const [fieldsToHide, setFieldsToHide] = useState([
    'orderNotEligibleforMssReason',
    'reasonForOrderReturned'
  ]);
  const reasonForSubmissions = staticLabels['reasonForFubmissionList'];
  const orderNotEligibleForMSSReasons =
    staticLabels['OrderNotEligibleForMSSReasonList'];
  const flags = staticLabels['filterByFlagsList'];
  const reasonsForOrderReturned = staticLabels['filterByReturningReasonList'];
  const filterData = {
    salesRepNames,
    channels,
    provinces,
    dealerships,
    reasonForSubmissions: reasonForSubmissions,
    orderNotEligibleForMSSReasons: orderNotEligibleForMSSReasons,
    flags: flags,
    reasonsForOrderReturned: reasonsForOrderReturned
  };

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
    const hiddenFields = fieldsToHide;
    if (key === 'reasonForSubmission') {
      hiddenFields.indexOf('orderNotEligibleforMssReason') == -1
        ? hiddenFields.push('orderNotEligibleforMssReason')
        : null;
      value.value === orderIsNotEligibleForMSS
        ? (hiddenFields.splice(
            hiddenFields.indexOf('orderNotEligibleforMssReason'),
            1
          ),
          setFieldsToHide(hiddenFields))
        : setFieldsToHide(hiddenFields);
    }
    if (key === 'flag') {
      hiddenFields.indexOf('reasonForOrderReturned') == -1
        ? hiddenFields.push('reasonForOrderReturned')
        : null;
      value.value === orderWasReturned
        ? (hiddenFields.splice(
            hiddenFields.indexOf('reasonForOrderReturned'),
            1
          ),
          setFieldsToHide(hiddenFields))
        : setFieldsToHide(hiddenFields);
    }
  };

  const getFilterPayload = () => {
    let resonForSubmissionsList = [];
    if (filterState.reasonForSubmission) {
      resonForSubmissionsList.push(filterState.reasonForSubmission.value);
      resonForSubmissionsList.push(
        reasonForSubmissionFrenchMappings[filterState.reasonForSubmission.value]
      );
    }
    let orderNotEligibleforMssReasonList =
      filterState.reasonForSubmission &&
      filterState.reasonForSubmission.value === orderIsNotEligibleForMSS
        ? filterState.orderNotEligibleforMssReason.map(row => row.value)
        : [];
    if (orderNotEligibleforMssReasonList.length > 0) {
      for (const reason of filterState.orderNotEligibleforMssReason) {
        orderNotEligibleforMssReasonList.push(
          orderIsNotEligibleForMSSFrenchMappings[reason.value]
        );
      }
    }
    const payload = {
      ...filterState,
      createdBy: filterState.createdBy.map(row => row.value),
      province: filterState.province.map(row => row.value),
      status: filterState.status.map(row => row.value),
      channelId: filterState.channelId.map(row => row.value),
      dealership: filterState.dealership.map(row => row.value),
      reasonForSubmission: resonForSubmissionsList,
      orderNotEligibleforMssReason: orderNotEligibleforMssReasonList,
      flag: filterState.flag ? filterState.flag.value : null,
      reasonForReturningOrder:
        filterState.flag && filterState.flag.value === orderWasReturned
          ? filterState.reasonForOrderReturned.map(row => row.value)
          : []
    };
    delete payload.assignee;
    delete payload.reasonForOrderReturned;

    payload.filterCriteria = 'validatedAt';
    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    return _.omitBy(payload, _.isNil); // remove null and undefined values from the object
  };
  const applyFilters = () => {
    setPageNumber(1);
    localStorage.setItem('MyOrdersPageWLS', 1);
    filterOrders();
  };
  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchOrders();
    } else {
      const payload = getFilterPayload();
      setPageLoading(true);
      setFilters(payload);
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=wls&pageNumber=${pageNumber}&pageSize=${_.get(
            pageLayout,
            'ordersPerPage',
            10
          )}`,
          { ...payload },
          { ...axiosConfig() }
        )
        .then(response => {
          setOrdersList(
            addDevicesAndAccessoriesValues(_.get(response, 'data.results', []))
          );
          setTotalOrders(_.get(response, 'data.totalCount', 0));
          setPageLoading(false);
        })
        .catch(() => {});
    }
  };

  const resetFilters = () => {
    setFilters('');
    localStorage.setItem('AllOrdersPageWLS', 1); // reset local stored page number to page = 1
    setPageNumber(1); // reset state of page number to page = 1
    setFilterState({
      ...initialFilterState,
      province: [],
      channelId: [],
      assignee: [],
      channelOrgCode: [],
      outletCode: [],
      salesRepName: [],
      status: [],
      dealership: [],
      reasonForSubmission: null,
      orderNotEligibleforMssReason: [],
      flag: null,
      reasonForOrderReturned: []
    });
    setFieldsToHide(['orderNotEligibleforMssReason', 'reasonForOrderReturned']);
    filterOrders(true);
  };
  // API to fetch all WLS orders
  const fetchOrders = async () => {
    return axios
      .get(
        `${apiHost}/orders?typeOfOrder=wls&pageNumber=${pageNumber}&pageSize=${_.get(
          pageLayout,
          'ordersPerPage',
          10
        )}&${url}`,
        axiosConfig()
      )
      .then(response => {
        setOrdersList(
          addDevicesAndAccessoriesValues(_.get(response, 'data.results', []))
        );
        setTotalOrders(_.get(response, 'data.totalCount', 0));
      })
      .catch(() => {});
  };

  const fetchSalesReps = async () => {
    return axios
      .get(`${apiHost}/users/sales-reps`, axiosConfig())
      .then(response => {
        setSalesRepNames(_.get(response, 'data.salesReps', 0));
      })
      .catch(() => {});
  };

  const fetchDealerships = async () => {
    return axios
      .get(`${apiHost}/dealerships`, axiosConfig())
      .then(response => {
        setDealerships(_.get(response, 'data.rows', 0));
      })
      .catch(() => {});
  };

  const fetchChannels = async () => {
    return axios
      .get(`${apiHost}/channels`, axiosConfig())
      .then(response => {
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
    } else {
      url = filters; // findAll=0 (for MY Orders) & findAll=1 (for All Orders)
    }
    getContentfulData(config).then(async res => {
      setPageLayout(getData(res));
      setPageLoading(true);
      await Promise.all([
        fetchOrders(),
        fetchSalesReps(),
        fetchChannels(),
        fetchDealerships()
      ]);
      setPageLoading(false);
    });
  }, []);

  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
      localStorage.setItem('AllOrdersPageWLS', 1); // reset local stored page number to page = 1
      setPageNumber(1);
      fetchOrders();
    } else if (filters) {
      filterOrders();
    } else {
      fetchOrders();
    }
    setPageLoading(true);
    setPageLoading(false);
    handleHistoryPush(pageNumber);
  }, [pageNumber, searchString]);

  const showExportPopup = () => {
    setExportPopupVisible(true);
  };

  const hideExportPopup = () => {
    setExportPopupVisible(false);
  };

  const onSearchClick = () => {
    history.push({
      search: `?q=${searchString}`
    });
  };

  const onClear = () => {
    setSearchString('');
    history.push({
      search: ''
    });
  };

  const onExportOrders = type => {
    setExportingOrders(true);
    const endDate = moment(new Date()).format('YYYY-MM-DD');
    const startDate = moment(new Date())
      .subtract(3, 'month')
      .format('YYYY-MM-DD');
    const payloadAll = {
      filterCriteria: 'validatedAt',
      startDate,
      endDate
    };
    const payloadFilters = getFilterPayload();
    const exportUrl = `${apiHost}/orders/export/excel?typeOfOrder=wls`;
    axios
      .post(
        exportUrl,
        {
          ...(type === 'all' ? payloadAll : payloadFilters)
        },
        { responseType: 'arraybuffer', ...axiosConfig() }
      )
      .then(response => response.data)
      .then(fileData => {
        FileDownload(fileData, 'WLS_Orders.xlsx');
        setExportingOrders(false);
      })
      .catch(() => {});
  };

  return (
    <>
      <DimpleDivider />
      <div style={{ padding: '0 6rem' }}>
        <Filters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={{ ...staticLabels, wlsFiltersStatusOptions }}
          fieldsToHide={fieldsToHide}
          isWlsFilter={true}
        />
        <Search>
          <div></div>
          <InputGroup
            label={searchLabel}
            hint={searchHint}
            style={{ marginLeft: 20 }}
            defaultValue={searchString}
            onClearButtonClick={() => onClear()}
            onChange={e => setSearchString(e.target.value)}
            onButtonClick={() => onSearchClick()}
            onKeyDown={e => e.key === 'Enter' && onSearchClick()}
          />
        </Search>
      </div>
      <DimpleDivider />
      <ContentWrapper style={{ padding: '0 4rem', marginBottom: 0 }}>
        {pageLoading && <Spinner spinning label="Loading Orders..." />}
        {!pageLoading && ordersList.length === 0 ? (
          <p style={{ textAlign: 'center' }}>{noOrders}</p>
        ) : (
          <>
            {isDelete && isDelete.action && (
              <Box>
                <MessageNotification
                  variant="success"
                  message={stringInterpolation(
                    successActionMessage,
                    cancelAction,
                    isDelete.orderId
                  )}
                />
              </Box>
            )}
            <Box
              style={{
                margin: '2rem',
                border: '1px solid #e3e3e3'
              }}
            >
              <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
              </TopbarWrapper>
              <Table
                pageLayout={pageLayout}
                data={ordersList}
                fetchOrders={fetchOrders}
                setIsDelete={setIsDelete}
              />
            </Box>
            <Pagination
              ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
              totalOrders={totalOrders}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
            />
          </>
        )}
        <TableBottomBar>
          <Button onClick={showExportPopup}>Export Orders</Button>
        </TableBottomBar>
      </ContentWrapper>
      <ExportOrdersModal
        isLoading={exportingOrders}
        onExportOrders={onExportOrders}
        isVisible={isExportPopupVisible}
        onClose={hideExportPopup}
      />
    </>
  );
};

export default AllOrdersDashboardWLS;
